import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class RouterService {
  readonly #router = inject(Router);
  readonly #location = inject(Location);

  readonly #invalidRoutes = [
    'error',
    'page-not-found',
    'client-setup'
  ] as const;

  navigateWithReplace(routerUrl: string): void {
    queueMicrotask(() => {
      void this.#router.navigateByUrl(routerUrl, { replaceUrl: true });
    });
  }

  //#region Getters

  get currentFullRoute(): string | null {
    const currentRoute = this.#location.path();
    const splitUrl = currentRoute.split('/');

    if (!currentRoute || splitUrl.length < 1) {
      return null;
    }

    splitUrl.splice(0, 3);
    const routerUrl = splitUrl.join('/');

    const isInvalid = new RegExp(this.#invalidRoutes.join('|')).test(routerUrl);

    return !routerUrl || isInvalid ? null : routerUrl;
  }

  get currentParentRoute(): string | null {
    const parentRoute = this.getParentRoute(this.#location.path().substring(1));

    return new RegExp(this.#invalidRoutes.join('|')).test(parentRoute ?? '')
      ? null
      : parentRoute;
  }

  //#endregion

  private getParentRoute(routerUrl: string): string | null {
    const splitUrl = routerUrl.split('/');

    if (!routerUrl || splitUrl.length < 1) {
      return null;
    }

    // [0]: clientId; [1]: projectId; [2]: parent
    let parentUrl = splitUrl[2] ?? null;

    if (new RegExp(this.#invalidRoutes.join('|')).test(routerUrl)) {
      parentUrl = '';
    }

    return parentUrl;
  }
}
